/*
 * Scrolls to the product grid after a category is picked in the collection sidebar
 * (.categories-group in snippets/filters.liquid). Those links load a new collection page,
 * which would otherwise open at the hero banner. Direct visits, reloads and back/forward
 * navigation are not affected: the flag is only set by a click and is consumed once.
 */
(function () {
  const STORAGE_KEY = 'hg:scroll-to-products';
  const LINK_SELECTOR = '.categories-group .collection-nav a[href]';
  const GRID_SELECTOR = '[data-products-grid]';
  const NAV_SELECTOR = '[data-collection-nav]';
  const ACTIVE_SELECTOR = '.categories-group .sidebar__item--active > a';

  function readFlag() {
    try {
      const path = window.sessionStorage.getItem(STORAGE_KEY);
      window.sessionStorage.removeItem(STORAGE_KEY);
      return path;
    } catch (error) {
      return null;
    }
  }

  function writeFlag(path) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, path);
    } catch (error) {
      // Storage unavailable (private mode): fall back to the default page load.
    }
  }

  // Delegated, because the sidebar markup is replaced after AJAX filtering.
  document.addEventListener('click', (event) => {
    const link = event.target.closest(LINK_SELECTOR);
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey) return;

    writeFlag(new URL(link.href, window.location.origin).pathname);
  });

  // The sidebar is a sticky panel with its own scroll box; a long category list (e.g. the level-4
  // children of Hautpflege) leaves the active item below its fold, so scroll that box to it.
  // pageFollows: the page is about to be scrolled to the grid, which pins the box under the header.
  // Otherwise (direct visit) the box may still reach below the viewport; nudge the page just enough.
  function revealActiveCategory(pageFollows) {
    const items = document.querySelectorAll(ACTIVE_SELECTOR);
    const link = items[items.length - 1];
    if (!link || !link.offsetParent) return;

    let box = link.parentElement;
    while (box && box !== document.body) {
      const overflow = window.getComputedStyle(box).overflowY;
      if ((overflow === 'auto' || overflow === 'scroll') && box.scrollHeight > box.clientHeight) break;
      box = box.parentElement;
    }

    if (box && box !== document.body) {
      const offset = link.getBoundingClientRect().top - box.getBoundingClientRect().top;
      if (offset < 0 || offset + link.offsetHeight > box.clientHeight) {
        box.scrollTop += offset - (box.clientHeight - link.offsetHeight) / 2;
      }
    }

    // Back/forward and reload keep the position the browser restores.
    if (pageFollows || (navigation && navigation.type !== 'navigate')) return;

    // Skip when the sidebar is a closed off-canvas drawer (mobile): the item shows once it opens.
    if (window.getComputedStyle(link).visibility === 'hidden') return;
    const rect = link.getBoundingClientRect();

    const margin = 120; // keeps the item clear of the cookie bar
    const overflow = rect.bottom - (window.innerHeight - margin);
    if (overflow > 0) window.scrollTo({top: window.scrollY + overflow, left: 0, behavior: 'auto'});
  }

  const flaggedPath = readFlag();
  const navigation = window.performance.getEntriesByType && window.performance.getEntriesByType('navigation')[0];
  const scrollToGrid = Boolean(flaggedPath) && flaggedPath === window.location.pathname && !(navigation && navigation.type !== 'navigate');
  const revealOnReady = () => revealActiveCategory(scrollToGrid);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealOnReady, {once: true});
  } else {
    revealOnReady();
  }

  if (!scrollToGrid) return;

  let userScrolled = false;
  const markUserScrolled = () => {
    userScrolled = true;
  };
  ['wheel', 'touchstart', 'keydown'].forEach((type) => window.addEventListener(type, markUserScrolled, {once: true, passive: true}));

  // Same offset as the theme uses after AJAX filtering (collection-filters-form.js).
  function scrollToProducts(smooth) {
    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;

    const nav = document.querySelector(NAV_SELECTOR);
    const top = grid.getBoundingClientRect().top - (nav ? nav.offsetHeight : 0);

    if (smooth && window.theme && typeof window.theme.scrollTo === 'function') {
      window.theme.scrollTo(top);
      return;
    }

    const header = document.querySelector('[data-header-sticky]') ? document.querySelector('[data-header-height]') : null;
    window.scrollTo({top: top + window.scrollY - (header ? header.offsetHeight : 0), left: 0, behavior: smooth ? 'smooth' : 'auto'});
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function start() {
    scrollToProducts(!reducedMotion);

    // Late images or fonts can shift the grid; correct once if the visitor has not scrolled yet.
    if (document.readyState !== 'complete') {
      window.addEventListener('load', () => {
        if (!userScrolled) scrollToProducts(false);
      }, {once: true});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {once: true});
  } else {
    start();
  }
})();
